var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('el-image',{attrs:{"src":_vm.collapse?_vm.logoVertical:_vm.logo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }